<p-progressSpinner *ngIf="!showTable" [style]="{width: '50px', height: '50px'}" fxFlex="1 1 auto" class="spinner" animationDuration="2s"></p-progressSpinner>

<p-table *ngIf="showTable" [value]="tableData" scrollable="true" scrollHeight="100%" [rows]="12" [paginator]="false"
    dataKey="dataKey" [(first)]="currentFirstShownRowIndex" class="liquitics-compact-table" styleClass="p-datatable-striped">
    <ng-template pTemplate="caption">
        <span fxFlex="1 1 auto" fxFlexAlign="center">Projections</span>
        <button fxFlex="0 0 auto" fxFlexAlign="right" type="button" pButton icon="fa fa-plus-square" (click)="addProjection()" label="New"></button>
    </ng-template>

    <ng-template pTemplate="header">
        <tr>
            <th style="width:7%"></th>
            <th [pSortableColumn]="'targetName'" [style]="{'text-align':'center'}">
                <span> </span>
                <p-sortIcon [field]="'targetName'"></p-sortIcon>
            </th>
            <th *ngIf="!singleCurrency" [style]="{'text-align':'center'}">
                <span>Currency</span>
                <p-sortIcon [field]="'currency'"></p-sortIcon></th>
            <th [style]="{'text-align':'center'}">Assumed Amount</th>
            <th [style]="{'text-align':'center'}">Filled</th>
            <th style="width:7%"></th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-row>
        <tr>
            <td>
                <span class="jump-to-history fa fa-clock-o" (click)="onHistory(row)"></span>
            </td>
            <td>{{row.targetName}}</td>
            <td>{{row.currency}}</td>
            <td>
                <span>{{row.projectedAmount | currencyrounding:2:row.currency:'symbol-narrow' | negativeparentheses}}</span>
            </td>
            <td>
                <span>{{row.filledAmount | currencyrounding:2:row.currency:'symbol-narrow' | negativeparentheses}}</span>
            </td>
            <td>
                <span class="edit-projection fa fa-pencil" (click)="editProjection(row)"></span>
            </td>
        </tr>
    </ng-template>



    <!-- <p-header fxLayout="row">
        <span fxFlex="1 1 auto" fxFlexAlign="center">Projections</span>
        <button fxFlex="0 0 auto" fxFlexAlign="right" type="button" pButton icon="fa fa-plus-square" (click)="addProjection()" label="New"></button>
    </p-header> -->

<!--Already commented-->
    <!-- <p-dataTable [value]="tableData" scrollable="true" [rows]="12" [paginator]="true" > -->
<!-- 
    <p-column field="" header="" [style]="{'width':'7%','text-align':'center'}">
        <ng-template let-entry="rowData" pTemplate="body">
            <span class="jump-to-history fa fa-clock-o" (click)="onHistory(entry)"></span>
        </ng-template>
    </p-column> -->
<!--Already commented-->
    <!-- <p-column [styleClass]="'col-rule-name'" field="ruleName" header="Rule Name" [style]="{'width':'30%','text-align':'left'}"></p-column>
    <p-column [styleClass]="'col-rule-percentage'" field="rulePercentage" header="%" [style]="{'text-align':'center'}"></p-column> -->
    <!-- <p-column [styleClass]="'col-client'" field="targetName" header=" " [sortable]="true" [style]="{'width':'40%','text-align':'center'}"></p-column>
    <p-column *ngIf="!singleCurrency" [styleClass]="'col-currency'" field="currency" header="Currency" [sortable]="true" [style]="{'text-align':'center'}"></p-column>
    <p-column [styleClass]="'col-assumed-amount'" field="projectedAmount" header="Assumed Amount" [sortable]="false" [style]="{'text-align':'center'}">
        <ng-template let-row="rowData" pTemplate="body"> -->
<!--Already commented-->
            <!-- <span>{{row.netProjectedAmount | number : '1.1-1' | negativeparentheses}}</span> -->
            <!-- <span>{{row.projectedAmount | currencyrounding:2:row.currency:'symbol-narrow' | negativeparentheses}}</span>
        </ng-template>
    </p-column> -->
<!--Already commented-->
    <!-- <p-column [styleClass]="'col-completed-percentage'" field="completionPercentage" header="% Complete" [sortable]="true" [style]="{'text-align':'center'}">
        <ng-template let-row="rowData" pTemplate="body">
            <span>{{row.completionPercentage | number : '1.0-0'}}</span>
        </ng-template>
    </p-column> -->
<!--     
    <p-column [styleClass]="'col-filled-amount'" field="filledAmount" header="Filled" [sortable]="true" [style]="{'text-align':'center'}">
        <ng-template let-row="rowData" pTemplate="body">
            <span>{{row.filledAmount | currencyrounding:2:row.currency:'symbol-narrow' | negativeparentheses}}</span>
        </ng-template>
    </p-column>
    <p-column [styleClass]="'col-edit'" field="" header="" [style]="{'width':'7%','text-align':'center'}">
        <ng-template let-entry="rowData" pTemplate="body">
            <span class="edit-projection fa fa-pencil" (click)="editProjection(entry)"></span>
        </ng-template>
    </p-column> -->
</p-table>